import request from '@/util/http'

export const submitElectronicBank = (data) => {
  return request({
    url: '/zcjf/biz/guarantee/bank/submitElectronicBank',
    method: 'post',
    data,
  })
}

export const queryBankByPlatform = (params) => {
  return request({
    url: '/zcjf/biz/guarantee/bank/queryBankByPlatform',
    method: 'get',
    params,
  })
}
